/**
 * Fechas de entrega estimadas para productos pre-order.
 * Formato: SKU (barcode) -> fecha de entrega
 *
 * Para agregar un producto nuevo:
 *   1. Copia un bloque existente
 *   2. Cambia el comentario con el código del producto
 *   3. Agrega los SKUs de cada talla con la fecha de entrega
 */
function getPreorderDates() {
  return {
    //DMCA-250041
    '202500023996': '07 de agosto',
    '202500024009': '07 de agosto',
    '202500024016': '07 de agosto',
    '202500024023': '07 de agosto',
    //TBSM-260010
    '202600018403': '24 de julio',
    '202600018410': '24 de julio',
    '202600018427': '24 de julio',
    '202600018434': '24 de julio',
    //tbmc-260033
    '202600019349': '07 de agosto',
    '202600019356': '07 de agosto',
    '202600019363': '07 de agosto',
    '202600019370': '07 de agosto',
    //OCHA-250030
    '202500091995': '14 de agosto',
    '202500092008': '14 de agosto',
    '202500092015': '14 de agosto',
    '202500092022': '14 de agosto',
    // TBSM-260120
    '202600020765': '14 de agosto',
    '202600020772': '14 de agosto',
    '202600020789': '14 de agosto',
    '202600020796': '14 de agosto',
    // TBSM-260119
    '202600019301': '14 de agosto',
    '202600019318': '14 de agosto',
    '202600019325': '14 de agosto',
    '202600019332': '14 de agosto',

  };
}
